import { render, staticRenderFns } from "./creat-icon.vue?vue&type=template&id=3f2d3367&scoped=true"
import script from "./creat-icon.vue?vue&type=script&lang=js"
export * from "./creat-icon.vue?vue&type=script&lang=js"
import style0 from "./creat-icon.vue?vue&type=style&index=0&id=3f2d3367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d3367",
  null
  
)

export default component.exports